export default __webpack_public_path__ + "assets/space_tugs.081d9a7e.png";